import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { AppDispatch } from "../redux/store";
import axiosInstance from "../services/axiosInstance";
import { AuthState, getCurrentUser } from "../redux/slices/authSlice";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import Loader  from "../components/common/Loader"
 
type AuthGuardProps = {
  children: React.ReactNode;
};

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const [showTokenExpiryModal, setShowTokenExpiryModal] =
    useState<boolean>(false);

  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { currentUser, loading } = useSelector<unknown, AuthState>(
    (state: any) => state.auth
  );

  useEffect(() => {
    const axiosInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 401) {
          setShowTokenExpiryModal(true);
        }
        return Promise.reject(error);
      }
    );
    if (!currentUser) {
      dispatch(getCurrentUser());
    }

    return () => {
      axiosInstance.interceptors.response.eject(axiosInterceptor);
    };
  }, [currentUser, dispatch, navigate]);

  const handleLoginRedirect = () => {
    sessionStorage.setItem("session_expired", "true")
    navigate("/auth",{ replace: true }); 
    window.location.reload(); 
    setShowTokenExpiryModal(false);
  };

  if (loading) {
    return <div className="flex items-center justify-center h-screen"><Loader/></div>;
  }


  return (
    <div className="w-full">
      {children}
      <Dialog
        visible={showTokenExpiryModal}
        modal
        onHide={() => {}}
        content={({ hide }) => (
          <div className="bg-white rounded-md p-4 flex flex-col gap-4">
            <div className="flex items-center gap-3">
              <i className="pi pi-exclamation-triangle text-primary-400"></i>
              <span className="text-black">Session Expired</span>
            </div>
            <p>Your session has expired. Please log in again to continue.</p>
            <Button
              label="Go to Login"
              onClick={handleLoginRedirect}
              className="bg-primary-500 text-white self-end hover:bg-primary-600"
            />
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default AuthGuard;
